import user from './api.js'
export default {
  user
}